/**
 * The signed-in user as the interface needs it: loaded once per page load, shared by the shell
 * and the pages that draw differently for an operator and for a customer user.
 *
 * Only a hint for drawing: every endpoint checks for itself, and a customer user who types
 * /servers gets the backend's 403, not a hidden page.
 */
import { api } from './api/index.js';

let loading = null;

/** `{ username, admin, operator, customers }`; rejects with the API error (401 without a session). */
export function currentViewer() {
  loading ??= api.session().catch((error) => {
    loading = null;
    throw error;
  });
  return loading;
}

/** Forgets the cached viewer, e.g. when the demo switches who it shows the plane as. */
export function forgetViewer() {
  loading = null;
}
